var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col bg-white min-h-screen"},[_c('page-header',{attrs:{"hide_navbar":_vm.hide_navbar}}),_vm._v(" "),_c('blogs'),_vm._v(" "),_c('fixed-contact-us-pop-up')],1)}
var staticRenderFns = []

export { render, staticRenderFns }